/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ path: NonNullable<unknown> }} Canvas_File_Pick_Saved_UnreadInputs */



/**
* | output |
* | --- |
* | "The file was saved as {path}, but it could not be read back." |
*
* @param {Canvas_File_Pick_Saved_UnreadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_file_pick_saved_unread = /** @type {((inputs: Canvas_File_Pick_Saved_UnreadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_File_Pick_Saved_UnreadInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Datei wurde als ${i?.path} gespeichert, konnte aber nicht zurückgelesen werden.`)
	return /** @type {LocalizedString} */ (`The file was saved as ${i?.path}, but it could not be read back.`)
});